import React from 'react';
import { InfoPagesLayout } from 'Components/InfoPagesLayout/InfoPagesLayout';
import routes from 'common/constants/routing.constants';

export const SuccessEmailVerifiedPage = () => (
  <InfoPagesLayout to={routes.profile.path} linkText="Go to profile">
    Your email was successfully verified.
  </InfoPagesLayout>
);
